export class TreeNodeModel {
  public key: string;
  public label: string;
  public data: any;
  public icon: string;
  public children: Array<TreeNodeModel>
}